/**
 * Asynchronously loads the Settings component
 */

import loadable from "utils/loadable";

export default loadable(() => import("./index"));
